import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';

import { Button, Input, Toggle } from '@loyalup/ui';

import s from './TriggerNotification.module.css';

const TrigNotification = ({ type, text, onChangeText, enabled, setToggle, onActivate, onSave, loading }) => {
  const [t] = useTranslation();

  const title = {
    PASS_ACTIVATION: t('Push-уведомление после активации карты'),
    BDAY: t('Push-уведомление на День Рождения'),
  };

  return (
    <div onClick={onActivate} className={s.root}>
      <Toggle
        label={`${title[type]} (${enabled ? t('Включено') : t('Выключено')})`}
        checked={enabled}
        onChange={setToggle}
        className={s.header}
      />
      <Input theme="toolbar-white" type="textarea" onChange={text => onChangeText(text)} value={text} rows={6} />
      <CSSTransitionGroup
        transitionName={{
          enter: s.enter,
          enterActive: s.enterActive,
          leave: s.leave,
          leaveActive: s.leaveActive,
        }}
        transitionEnterTimeout={150}
        transitionLeaveTimeout={150}
      >
        <div className={s.buttons}>
          <Button loading={loading} onClick={onSave}>
            {t('Сохранить изменения')}
          </Button>
        </div>
      </CSSTransitionGroup>
    </div>
  );
};

TrigNotification.propTypes = {
  type: PropTypes.oneOf(['BDAY', 'PASS_ACTIVATION']).isRequired,
  text: PropTypes.string,
  onChangeText: PropTypes.func.isRequired,
  enabled: PropTypes.bool.isRequired,
  setToggle: PropTypes.func.isRequired,
  onActivate: PropTypes.func,
  onSave: PropTypes.func.isRequired,
};

export default TrigNotification;
